/**
 * * Запрос поиска по таймерам
 */
export default class GetListRequest  {
	/**
	 * * Ид задачи
	 */
	TaskId!: number;
	/**
	 * * Номер исполнителя
	 */
	PerformerId?: number;
	constructor(obj?: Partial<GetListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
